import apiClient from '../services/apiClient'

/**
 * Token Manager - Gestion de compatibilité pendant la migration vers les cookies httpOnly
 *
 * Ces fonctions maintiennent la compatibilité avec le code existant pendant la migration.
 * À terme, elles seront supprimées lorsque toute la base de code sera migrée vers apiClient.
 */

// Fonction de compatibilité - retourne null car les tokens sont maintenant dans les cookies
export const getStoredToken = (tokenType: 'Admin' | 'Member' | 'Coach'): string | null => {
    // Les tokens sont maintenant gérés par les cookies httpOnly
    // Cette fonction est maintenue pour la compatibilité pendant la migration
    return null
}

// Fonction de compatibilité - ne fait rien car les tokens sont dans les cookies
export const clearToken = (tokenType: 'Admin' | 'Member' | 'Coach'): void => {
    // Les tokens sont maintenant gérés par les cookies httpOnly
    // Cette fonction est maintenue pour la compatibilité pendant la migration
    // Le nettoyage des tokens se fait via l'endpoint de logout
}

// Fonction pour nettoyer tous les tokens via l'API
export const clearTokens = async (): Promise<void> => {
    try {
        await apiClient.post('/users/logout')
    } catch (error) {
        console.error('Error clearing tokens:', error)
        // En cas d'erreur, on redirige quand même vers login
        window.location.href = '/login'
    }
}

// Fonction pour nettoyer un token spécifique via l'API
export const clearTokenByRole = async (role: 'Admin' | 'Member' | 'Coach'): Promise<void> => {
    try {
        await apiClient.post('/users/logout', { role })
    } catch (error) {
        console.error(`Error clearing ${role} token:`, error)
        // En cas d'erreur, on redirige quand même vers login
        window.location.href = '/login'
    }
}

// Fonction pour vérifier si l'utilisateur est authentifié
// Cette fonction sera utilisée pendant la transition
export const isAuthenticated = (): boolean => {
    // Pendant la migration, on considère que si on a un cookie valide, on est authentifié
    // La vérification réelle se fera via les appels API qui retourneront 401 si non authentifié
    return true
}
